import clsx, { type ClassValue } from "clsx";

const Noise = ({ className }: { className?: ClassValue | ClassValue[] }) => {
  return (
    <div
      className={clsx(
        "absolute inset-0 opacity-[0.05] pointer-events-none mix-blend-overlay",
        className,
      )}
    >
      <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <filter id="noiseFilter">
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.65"
            numOctaves="3"
            stitchTiles="stitch"
          />
        </filter>
        <rect width="100%" height="100%" filter="url(#noiseFilter)" />
      </svg>
    </div>
  );
};

export default Noise;
